import React from 'react';
import { ProductFilters } from '../../../../app/models/Product'

type Props = {
    filter: ProductFilters;
    setFilter: (filter: ProductFilters) => void;
};

const ProductFilter = ({ filter, setFilter }: Props) => {

    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };


    return (
        <div className="row">
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="patent">
                        Nombre
                    </label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control form-control-sm"
                        value={filter.name}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="sector">
                        Sector
                    </label>
                    <input
                        title="Sector"
                        type="text"
                        id="sector"
                        name="sector"
                        className="form-control form-control-sm"
                        value={filter.sector}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="item_category">
                        Categoría
                    </label>
                    <input
                        title="Categoría"
                        type="text"
                        id="item_category"
                        name="item_category"
                        className="form-control form-control-sm"
                        value={filter.item_category}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProductFilter;
